import { ApolloProvider } from '@apollo/client';
import 'styles/main.scss';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import RouteSwitch from './views/system/RouteSwitch';
import theme from './styles/themes/default/defaultTheme';
import { client, store } from './client';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename={'/'} forceRefresh={false}>
          <RouteSwitch />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </ApolloProvider>,
  document.getElementById('app')
);
